<template>
	<page-content-layout class="employees" title="Medarbejdere">
		<button-group-view slot="tools" :actions="[
			{
				label: 'Aktive',
				value: 'Aktiv'
			},
			{
				label: 'Inaktive',
				value: 'Inaktiv'
			}
		]" v-model="active" />
		<button-view v-show="checked.length > 0" slot="tools" label="SMS" @click="createTextButtonClick" />
		<button-view v-show="checked.length > 0" slot="tools" label="E-mail" @click="createEmailButtonClick" />
		<button-view slot="tools" label="Opret" @click="createButtonClick" />
		<new-table-view ref="table" v-model="checked" @colclick="colclick" :columns="_columns" :items="_items" @itemClick="itemClick" @context="itemContext" />
	</page-content-layout>
</template>

<script>
	import Window from '../windows/EmployeeWindow'
	import MailWindow from '../windows/MailWindow'
	import TextWindow from '../windows/TextWindow'
	import EmployeeHistoryWindow from '../windows/EmployeeHistoryWindow'
	import NewTableView from '../views/NewTableView'
	import ContextPopupView from '../views/ContextPopupView'

	import { bus } from '../../bus'

    export default {
		props: [],
		components: {
			newTableView: NewTableView
		},
		computed: {
			_columns() {
				return [
					{
						label: this._roles_table[this.role],
						name: 'name',
						options: this._roles,
						template: {
							name: 'profile',
							params: {
								photo: {
									name: ['_links', 'photo_48x48', 'href']
								},
								name: {
									name: 'name'
								},
								title: {
									name: 'title'
								}
							}
						}
					},
					{
						label: 'Nr',
						name: 'number'
					},
					{
						label: 'Initialer',
						name: 'initials'
					},
					{
						label: 'Status',
						name: 'status'
					},
					{
						label: 'Notifikationer',
						name: 'notifications'
					},
					{
						label: 'Telefon',
						name: 'phone'
					},
					{
						label: 'E-mail',
						name: 'email'
					},
					{
						label: '',
						name: 'context',
						align: 'right',
						template: {
							name: 'button',
							label: '...'
						}
					}
				];
			},
			_roles_table() {
				return this._roles.reduce((acc, item) => {
					if (item !== null) acc[item.value] = item.label;
					return acc;
				}, {});
			},
			_roles() {
				var r = [
					{
						label: 'Alle',
						value: 'all',
						highlight: true,
					},
					null
				];

				

				for (var i = 0; i < this.roles.length; ++i) {
					r.push({
						label: this.roles[i].label,
						value: this.roles[i].name
					});
				}

				return r;
			},
			_items() {
				var r = [];
				var e;

				if (this.items !== null) {
					for (var i = 0; i < this.items.length; ++i) {
						e = this.items[i];

						
						
						if ((this.role == 'all' || (e.roles && e.roles[this.role] && e.roles[this.role].enabled)) && e.status == this.active) {
							r.push(e);
						}
					}
				}

				return r;
			}
		},
		methods: {
			colclick(col, opt) {
				
				this.role = opt.value;
			},
			createTextButtonClick() {
				var self = this;

				this.$store.state.windowStack.push(TextWindow, {
					entity: {
						recipients: this.checked.map(function (item) { return item.phone; }).join("\n")
					},
					async submit(entity) {
						self.$store.state.windowStack.pop();
						var count = (await self.axios.post('/messages/texts/', entity)).data;
						alert('Sendt til ' + count + ' modtagere');
					}
				});
			},
			createEmailButtonClick() {
				var self = this;

				this.$store.state.windowStack.push(MailWindow, {
					entity: {
						recipients: this.checked.map(function (item) { return item.email; }).join("\n")
					},
					async submit(entity) {
						self.$store.state.windowStack.pop();
						var count = (await self.axios.post('/messages/emails/', entity)).data;
						alert('Sendt til ' + count + ' modtagere');
					}
				});
			},
			createButtonClick: function () {
				var contacts = this;

				this.$store.state.windowStack.push(Window, {
					onChange: function (ent) {
						
						

						contacts.update();
					}
				});
			},
			itemClick: function (item) {
				var contacts = this;

				this.$store.state.windowStack.push(Window, {id: item.id, form: true, onChange: function () {
					contacts.update();
				}});
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/employees/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			itemContext(item, event) {
				event.stopPropagation();

				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: [
						{
							label: 'Historik',
							action: async function () {
								self.$store.state.windowStack.push(EmployeeHistoryWindow, {
									id: item.id, 
									submit: async function (entity) {
										
									}
								});
							}
						},
						{
							label: 'Send test notifikation',
							action: async function () {
								self.axios.post('/employees/' + item.id + '/notifications/test/');
							}
						},
						{
							label: 'Præstation',
							action: async function () {
								window.open(process.env.VUE_APP_API + '/employees/' + item.id + '/performance/' + (new Date()).getFullYear() + '/?token=' + self.$store.state.auth);
							}
						},
						{
							label: 'Slet',
							action: async function () {
								self.itemDelete(item);
							}
						}
					]
				});
			},
			action: function (name, id) {
				if (name == 'delete' && confirm('Sure?')) {
					

					var contacts = this;

					this.axios
						.delete('/employees/' + id + '/')
						.then(function () {
							contacts.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var contacts = this;

				contacts.items = null;

				this.axios
					.get('/employees/')
					.then(function (r) {
						
						contacts.items = r.data._items;
					});
			}
		},
		data: function () {
			return {
				items: [],
				columns: [],
				actions: [
					{name: 'delete', label: 'Delete'}
				],
				active: 'Aktiv',
				checked: [],
				roles: [],
				role: 'all'
			};
		},
		mounted: function () {
			this.axios.put('/activity/employees/');

			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});

			this.axios
				.get('/employees/roles/')
				.then(function (r) {
					self.roles = r.data._items;
				});


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss">
	.new-table-view {
		width: 100%;
		height: 100%;
	}
</style>